import React from "react";
import useToggle from "hooks/useToggle";
import { Swiper, SwiperSlide } from "components/swiper";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import CylindoViewer from "components/cylindo-viewer";
import { ReactComponent as Arrow } from "svgs/small-right-arrow.svg";
import { useSettings } from "hooks/useStore";
import Image from "components/image";
import clsx from "clsx/lite";

const MainSwiper = ({ filteredImages, productId, title, percentageDiscount, thumbsSwiper, hideCylindoDynaimcFeature }) => {
	const { updateCylindoState, productSettings } = useSettings(["updateCylindoState", "productSettings"]);
	const isFirstCylindo = filteredImages[0]?._type === "cylindo";
	const [showArrows, toggleArrows] = useToggle(isFirstCylindo);

	const handleSlideChange = (swiper) => {
		const isCylindo = filteredImages[swiper.activeIndex]?._type === "cylindo";
		updateCylindoState(productId, isCylindo);
		swiper.allowTouchMove = !isCylindo;
		if (isCylindo !== showArrows) toggleArrows();
	};

	return (
		<>
			<Swiper
				onSlideChange={handleSlideChange}
				spaceBetween={10}
				navigation={{ enabled: true, nextEl: ".gallery-right-arrow", prevEl: ".gallery-left-arrow" }}
				allowTouchMove={!isFirstCylindo}
				initialSlide={productSettings?.[productId]?.isCylindoFirstSlide || !isFirstCylindo ? 0 : 1}
				thumbs={{ swiper: thumbsSwiper }}
				modules={[FreeMode, Thumbs, Navigation]}
				className="w-full relative"
			>
				{filteredImages.map((image) => (
					<SwiperSlide key={image?._key} className={image._type}>
						{image?._type === "cylindo" ?
							<CylindoViewer
								code={image.code || title}
								initialFeatures={image?.features}
								curator={image.curatorCode}
								frame={image.frame}
								dynamicFeature={hideCylindoDynaimcFeature || !image.dynamicFeature?.enabled ? null : image.dynamicFeature}
							/> : (
								<>
									<Image image={image} className="relative" />
									{percentageDiscount > 0 &&
										<div className="top-5 left-5 flex swiper-content-overlay">
											<div className="bg-beige px-5 py-1.5">{percentageDiscount}% Off</div>
										</div>}
								</>
							)}
					</SwiperSlide>
				))}
			</Swiper>
			<button className={clsx("gallery-left-arrow", !showArrows && "hidden")}>
				<Arrow className="rotate-180" />
			</button>
			<button className={clsx("gallery-right-arrow", !showArrows && "hidden")}>
				<Arrow />
			</button>
		</>
	);
};

export default MainSwiper;